import React, {useEffect, useState} from "react";
import {Alert, Box, Snackbar, Typography} from "@mui/material";
import BottomBar from "./components/navigation/BottomBar";
import TopAppBar from "./components/navigation/TopAppBar";
import SvgTool from "./screens/tool/SvgTool";
import {ThemeProvider} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {darkTheme, lightTheme} from "./theme/Theme";

const Main = () => {
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [isDarkTheme, setIsDarkTheme] = useState(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);

    useEffect(() => {
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
            setIsDarkTheme(e.matches);
        });
    })

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    const onThemeChange = () => {
        setIsDarkTheme(!isDarkTheme);
    }

    return (
        <ThemeProvider theme={isDarkTheme ? darkTheme : lightTheme}>
            <CssBaseline/>
            <Box sx={{display: 'flex', flexDirection: 'column', height: '100vh'}}>
                <TopAppBar
                    isDarkTheme={isDarkTheme}
                    onThemeChange={onThemeChange}
                />

                <Box
                    sx={{
                        flexGrow: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <SvgTool setOpenSnackbar={setOpenSnackbar} setSnackbarMessage={setSnackbarMessage} isDarkTheme={isDarkTheme}/>
                </Box>

                <BottomBar isDarkTheme={isDarkTheme} />

                <Snackbar
                    open={openSnackbar}
                    autoHideDuration={3000}
                    onClose={handleCloseSnackbar}
                >
                    <Alert onClose={handleCloseSnackbar} severity="error" sx={{width: '100%'}}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </Box>
        </ThemeProvider>
    );
}

export default Main;